module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"temperature":"Temperature","moisture":"Moisture","top":"Top","bottom":"Bottom"},"de":{"temperature":"Temperatur","moisture":"Feuchtigkeit","top":"Oben","bottom":"Unten"},"fr":{"temperature":"Température","moisture":"Humidité","top":"Haut","bottom":"Bas"},"it":{"temperature":"Temperatura","moisture":"Umidità","top":"Sopra","bottom":"Sotto"}}')
  delete Component.options._Ctor
}
